import {Injectable} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import {Observable} from 'rxjs';
import { UserService } from '../services/user.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private userService: UserService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    let headers = req.headers.set('Client-Type', 'BROWSER');
    let newReq = req;
    
    if (token) {
      // 检查用户ID是否一致，防止多窗口越权
      const currentUserId = sessionStorage.getItem('currentUserId');
      if (currentUserId) {
        // 使用UserService的getUserInfo方法解析token
        const tokenInfo = this.userService.getUserInfo();
        if (tokenInfo && tokenInfo.id && tokenInfo.id.toString() === currentUserId) {
          // 用户ID一致，携带token
          headers = headers.set('token', token);
          newReq = req.clone({
            headers: headers
          });
        } else {
          // 用户ID不一致，不携带token，避免越权
          console.warn('用户ID不一致，不携带token发送请求，避免越权');
        }
      } else {
        // sessionStorage中没有用户ID，可能是首次登录，携带token
        headers = headers.set('token', token);
        newReq = req.clone({
          headers: headers
        });
      }
    }
    
    return next.handle(newReq);
  }
}
